export default "__VITE_ASSET__hcbE7TGx__"